
import { Component, Vue, Prop } from 'vue-property-decorator';
import TabNames from '@/services/tabNames';

@Component
export default class FieldAndPathTabs extends Vue {
  @Prop() selectedTab!: TabNames;

  tabNames = TabNames;
  tab = 0;

  mounted() {
    this.tab = Object.values(TabNames).indexOf(this.selectedTab);
  }
}
